import { computed } from 'vue';

import { useQuery } from '@tanstack/vue-query';

import { ENTITY_LIST_QUERY_OPTIONS } from '../constants';

import { queryKeys } from '../queryKeys';

import { accountBrands } from '@/api/routes/clusters';
import apiClient from '@/modules/ApiClient';
import { useAccountsService } from '@/modules/Accounts/services/AccountsService';

type BrandListItem = {
  id: string;
  name: string;
  [key: string]: unknown;
};

type BrandsListResponse = {
  data?: BrandListItem[];
};

export function useBrandsListQuery() {
  const accountsService = useAccountsService();
  const accountId = computed(() => accountsService.account?.id ?? '');

  return useQuery({
    queryKey: computed(() => queryKeys.brands.list(accountId.value)),
    queryFn: async () => {
      const { data } = await apiClient.request<BrandsListResponse>({
        method: 'GET',
        url: accountBrands,
        pathParams: {
          account: accountId.value,
        },
        params: {
          per_page: 1000,
          page_num: 1,
          filters: [
            {
              field: 'name',
              operator: 'like',
              value: '',
            },
          ],
        },
      });

      return data?.data ?? [];
    },
    enabled: computed(() => Boolean(accountId.value)),
    ...ENTITY_LIST_QUERY_OPTIONS,
  });
}
